module.exports = __webpack_public_path__ + "static/media/budworth_hardcastle.901ed538.png";